import React, {useEffect, useState} from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, makeStyles, Paper, Typography } from "@material-ui/core";
import PropTypes from 'prop-types';

import DialogCloseableTitle from "../DialogCloseableTitle";
import { useTranslation } from 'react-i18next';
import Draggable from 'react-draggable';
import ExcelFile from 'react-export-excel/dist/ExcelPlugin/components/ExcelFile';
import ExcelSheet from 'react-export-excel/dist/ExcelPlugin/elements/ExcelSheet';
import ExcelColumn from 'react-export-excel/dist/ExcelPlugin/elements/ExcelColumn';

const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: theme.zIndex.modal - 1
    },
    flexStyle: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%'
    }
  }));

  const PaperComponent = (props) => {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props}/>
        </Draggable>
    );
}
function UniDialog(props){
    const {title, message, children, open, 
        onSubmit, onClose, onFinish, openFunction, 
        cancelButtonText, finishButtonText, buttons,
        disableDefaultButtons, buttonDisabled, onDelete, enableDelete,
        contentStyle, autoClose, draggable, disableBackClick, 
         ...rest} = props
    const {t} = useTranslation('common');
    const classes = useStyles();

    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        if(open){
            openFunction()
        }
    }, [open])

    return (
        <Dialog 
            className={classes.root} 
            style={draggable?{pointerEvents: 'none'}:{pointerEvents: 'all'}}
            open={open}
            onClose={onClose}
            PaperComponent={PaperComponent} 
            hideBackdrop={draggable}
            disableBackdropClick={draggable || disableBackClick}
            disableEnforceFocus
            {...rest}
        >
            <DialogCloseableTitle onClose={onClose} 
                style={draggable?{cursor: 'move', pointerEvents: 'all'}:{cursor: 'default'}} id={draggable?"draggable-dialog-title":"none-draggable-dialog-title"}
            >
                {title}
            </DialogCloseableTitle>
            <DialogContent style={draggable?{pointerEvents: 'all'}:contentStyle}>
                {
                    Array.isArray(message) ?
                        message.map((line, index) => (
                            <Typography key={`message-${index}`}>
                                {line}
                            </Typography>
                        ))
                    :
                    message && message.length > 0 ?
                        <Typography>
                            {message}
                        </Typography>
                        :
                        null
                }
                
                {children}
            </DialogContent>
            {!disableDefaultButtons || buttons.length > 0 ?
                <DialogActions style={{padding: 16, pointerEvents: 'all'}}>
                {
                    buttons && buttons.length > 0 ?
                            <div className={enableDelete ? classes.flexStyle : ''}>
                                {
                                    enableDelete &&
                                    <div style={{ float: 'left' }}>
                                        <Button
                                            type="submit"
                                            onClick={onDelete} disabled={!enableDelete}
                                            color='secondary'
                                            variant='outlined'
                                        >
                                            {t('delete')}
                                        </Button>
                                    </div>
                                }
                                <div>
                                    {
                                        buttons.map((button, index) =>
                                        (
                                            button?.data?.length > 0 ?
                                                <ExcelFile
                                                    element={
                                                        <Button
                                                            variant={button.style}
                                                            disabled={button.disabled}
                                                            key={index}
                                                            color={button.color}
                                                            type="submit"
                                                            onClick={button.action}
                                                            id={button.id}
                                                            style={{ marginLeft: 16, marginRight: 10 }}
                                                        >
                                                            {button.text}
                                                        </Button>
                                                        }
                                                >
                                                    <ExcelSheet data={button.data} name={'Download'}>
                                                        {
                                                            Object.keys(button.data[0]).map((key) => (
                                                                <ExcelColumn label={key} value={key} />
                                                        ))
                                                        }
                                                    </ExcelSheet>
                                                </ExcelFile>
                                                :
                                                <Button
                                                    variant={button.style}
                                                    disabled={button.disabled}
                                                    key={index}
                                                    color={button.color}
                                                    type="submit"
                                                    onClick={button.action}
                                                    id={button.id}
                                                    style={{ marginLeft: 16, marginRight: 10 }}
                                                >
                                                    {button.text}
                                                </Button>
                                        )
                                        )
                                    }
                                </div>
                    </div>
                    :
                    <div style={{width: '100%', display: 'flex'}}>
                        {
                            onDelete && 
                            <div>
                                <Button type="submit" onClick={onDelete} disabled={!enableDelete}>
                                    {t('delete')}
                                </Button>
                            </div>
                        }
                        <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                            <Button type="submit" onClick={onClose}>
                                {cancelButtonText || t('cancel')}
                            </Button>
                            <Button color='primary' onClick={handleSubmit} disabled={buttonDisabled}>
                                {finishButtonText || t('submit')}
                            </Button>  
                        </div>
                    </div>
                }
                </DialogActions>
                :
                null
            }
        </Dialog>
    )

    function handleSubmit(){
        onFinish()
        if(autoClose){
            onClose()
        }
    }
}

UniDialog.defaultProps = {
    openFunction: ()=>{},
    buttons: [],
    disableDefaultButtons: false,
    autoClose: true,
    draggable: false
}

UniDialog.propTypes = {
    openFunction: PropTypes.func
}

export default React.memo(UniDialog)